import { cn } from '@/lib/utils';

interface TextSectionProps {
  content: {
    title?: string;
    content?: string;
    alignment?: 'left' | 'center' | 'right';
  };
  variant?: string;
  layoutStyle?: string;
}

export function TextSection({ content, variant = 'default', layoutStyle = 'classic' }: TextSectionProps) {
  const {
    title,
    content: textContent,
    alignment = 'center',
  } = content;

  const isMinimal = layoutStyle === 'modern-minimal';
  const isSerif = layoutStyle === 'elegant-serif';

  return (
    <section className="section-padding bg-background">
      <div className="container mx-auto px-4">
        <div className={cn(
          "max-w-3xl mx-auto space-y-6",
          alignment === 'left' && 'mx-0',
          alignment === 'right' && 'ml-auto mr-0',
          alignment === 'center' && 'text-center'
        )}>
          {title && (
            <h2 className={cn(
              "font-display font-bold text-foreground",
              isMinimal ? "text-3xl md:text-4xl tracking-tight" : 
              isSerif ? "text-3xl md:text-5xl italic" :
              "text-3xl md:text-4xl"
            )}>
              {title}
            </h2>
          )}
          {textContent && (
            <div className={cn(
              "prose prose-lg max-w-none text-muted-foreground",
              isSerif && "font-serif text-xl leading-relaxed"
            )}>
              {textContent.split('\n').map((paragraph, i) => (
                <p key={i}>{paragraph}</p>
              ))}
            </div>
          )}
        </div>
      </div>
    </section>
  );
}